@if (currentEmployeeObservable | async) {
	<mat-form-field appearance="fill" class="form-field-mdc-legacy form-field-mdc-legacy-white text-box lessPadding">
		<input
			matInput
			[matAutocomplete]="auto.matAutocomplete"
			#employeeInput
			appSanitizeInput
			(blur)="onLeaveText()"
			[formControl]="employeeForm"
		/>
		@if (employeeInput.value.length > 0) {
			<button mat-icon-button matSuffix aria-label="Clear" (click)="onClear()">
				<mat-icon>close</mat-icon>
			</button>
		}
		<app-employee-autocomplete #auto (elementSelected)="onItemChange($event)" [inputFormControl]="employeeForm">
		</app-employee-autocomplete>
	</mat-form-field>
}
